import "./EnhancedButtonPrimeReact.css";

import { Button } from "primereact/button";
import { Link } from "react-router-dom";
import React from "react";
import { StyledRouterLink } from "@websential/cosmic-v20";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export interface IEnhancedButtonPrimeReact {
  label?: any;
  icon?: React.ReactNode;
  loading?: boolean;
  onClickHandler?: () => void;
  iconPos?: "left" | "right" | "top" | "bottom";
  severity?:
  | "secondary"
  | "success"
  | "info"
  | "warning"
  | "danger"
  | "help"
  | "contrast";
  disabled?: boolean;
  raised?: boolean;
  rounded?: boolean;
  text?: boolean;
  outlined?: boolean;
  badge?: string;
  badgeClassName?: string;
  size?: "small" | "large";
  type?: "submit" | "reset" | "button";
  style?: React.CSSProperties; // Updated to React.CSSProperties for proper type
  className?: string;
  to?: string;
}

const isExternalLink = (url: string) => /^https?:\/\//i.test(url);

export const EnhancedButtonPrimeReact: React.FC<IEnhancedButtonPrimeReact> = ({
  label,
  icon,
  iconPos = "left",
  severity,
  disabled,
  raised,
  rounded,
  text,
  outlined,
  badge,
  badgeClassName,
  size = "small",
  type = "button",
  loading,
  onClickHandler,
  style,
  className,
  to,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <>
      {to ? (
        <StyledRouterLink to={to}>
          <Button
            icon={icon}
            iconPos={iconPos || undefined}
            loading={loading}
            onClick={onClickHandler}
            severity={severity || undefined}
            disabled={disabled}
            raised={raised}
            rounded={rounded}
            text={text}
            outlined={outlined}
            badge={badge || undefined}
            badgeClassName={badgeClassName || undefined}
            size={size || undefined}
            type={type || undefined}
            style={{
              ...style,
              borderRadius: rounded ? undefined : "2px",
              padding: to
                ? "0.53rem 1.09375rem"
                : rounded
                  ? "0.65625rem 1.09375rem"
                  : "0.5rem 1.59375rem",
            }}
            className={className}
          >
            <span style={{ fontWeight: "normal" }}>{label}</span>
          </Button>
        </StyledRouterLink>
      ) : (
        <Button
          icon={icon}
          iconPos={iconPos || undefined}
          loading={loading}
          onClick={onClickHandler}
          severity={severity || undefined}
          disabled={disabled}
          raised={raised}
          rounded={rounded}
          text={text}
          outlined={outlined}
          badge={badge || undefined}
          badgeClassName={badgeClassName || undefined}
          size={size || undefined}
          type={type || undefined}
          style={{
            ...style,
            borderRadius: rounded ? undefined : "2px",
            fontWeight: "normal",
            padding: isMobile ? "5px" : rounded ? "0.65625rem 1.09375rem" : "0.5rem 1.59375rem",
          }}
          className={`enhanced-button ${className || ""}`}
        >
          <span style={{ fontWeight: "normal", fontSize: isMobile ? ".7rem" : ".875rem" }}>{label}</span>
        </Button>
      )}
    </>
    //  {to && (
    // 	<Link to={to} style={{ color: "#fff", textDecoration: "none" }}>
    // 		{label}
    // 	</Link>
    // )} {to && isExternalLink(to) ? (
    // 	<a
    // 		href={to}
    // 		target="_blank"
    // 		rel="noopener noreferrer"
    // 		style={{ color: "#fff", textDecoration: "none" }}
    // 	>
    // 		{label}
    // 	</a>
    // ) : to ? (
    // 	<Link to={to} style={{ color: "#fff", textDecoration: "none" }}>
    // 		{label}
    // 	</Link>
    // ) : null}
  );
};
